export default __webpack_public_path__ + "static/media/ISSO CLASS-6_SYLLABUS_2025-26.c9a7ad59.pdf";